import Actions from "./common-actions";
import { createReducer } from "reduxsauce";

const INITIAL_STATE = { uiBlockingProcesses: [] };

const startUiBlockingProcess = (state, action) => {
  return {
    ...state,
    uiBlockingProcesses: Array.from(
      new Set([...state.uiBlockingProcesses, action.processId])
    )
  };
};

const endUiBlockingProcess = (state, action) => {
  return {
    ...state,
    uiBlockingProcesses: state.uiBlockingProcesses.filter(
      p => p !== action.processId
    )
  };
};

const HANDLERS = {
  [Actions.Types.START_UI_BLOCKING_PROCESS]: startUiBlockingProcess,
  [Actions.Types.END_UI_BLOCKING_PROCESS]: endUiBlockingProcess
};

export default createReducer(INITIAL_STATE, HANDLERS);



// WEBPACK FOOTER //
// ./src/modules/common/common-reducer.js